var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"change-mail-done"}},[_c('header-for-login'),(_vm.isLoading === true)?[_c('loading',{attrs:{"height":200}})]:[_c('b-card',{staticClass:"text-center mx-auto body-width pb-2",attrs:{"header-tag":"header"}},[_c('change-mail-form-done',{attrs:{"mail_address":_vm.mail_address}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }